import {FormColumn, FormContainer} from '../Form/Forms'
import FormTextInput from 'components/Control/Form/FormTextInput'
import {useI18n} from 'store/Store'
import {useFormContext} from 'react-hook-form'
import {FormRow} from '../Form/FormRow'
import FormSelect from 'components/Control/Form/FormSelect'
import {yesNoOptions} from 'constants/users'

const PublicationFolderForm = ({isNew}) => {
    const {i18n} = useI18n()

    const formContext = useFormContext()
    const {
        control,
        formState: {errors},
    } = formContext

    return (
        <FormContainer>
            <FormRow>
                <FormColumn>
                    <FormTextInput
                        readOnly
                        hidden={isNew}
                        name="_id"
                        label={i18n.t(`publications._id`)}
                        control={control}
                    />
                    <FormTextInput
                        name="nameHeb"
                        label={i18n.t(`publicationFolders.nameHeb`)}
                        control={control}
                        error={errors.nameHeb}
                    />

                    <FormTextInput
                        name="nameEng"
                        label={i18n.t(`publicationFolders.nameEng`)}
                        control={control}
                        error={errors.nameEng}
                    />
                </FormColumn>
                <FormColumn>
                    <FormTextInput
                        name="position"
                        type="number"
                        label={i18n.t(`publicationFolders.position`)}
                        control={control}
                        error={errors.position}
                    />
                    <FormSelect
                        itemsName="users"
                        optionsName="yesNo"
                        name="isActive"
                        label={i18n.t(`publicationFolders.isActive`)}
                        options={yesNoOptions}
                        control={control}
                        error={errors.isActive}
                    />
                </FormColumn>
            </FormRow>
        </FormContainer>
    )
}

export default PublicationFolderForm
